import { CommunitiesResponse as _CommunitiesResponse } from './fetchWebcastCommunities'
export { default, defaultState } from './fetchWebcastCommunities'
export type CommunitiesResponse = _CommunitiesResponse